import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import { useLocation } from '@gatsbyjs/reach-router'
import queryString from 'query-string'
import React, { useEffect, useMemo } from 'react'
import styled from 'styled-components'

import { CustomerInvoiceFragment } from '../../../../../graphql/camel'
import Link from '../../../../global/Link'
import { StyledActions, StyledHeader } from '../../orders/order/OrderPageContent'
import ReturnPolicy from '../../ReturnPolicy'
import InvoiceContents from './InvoiceContents'
import { InvoiceDetails } from './InvoiceDetails'
import { InvoiceTotal } from './InvoiceTotal'

const StyledReturnPolicy = styled(ReturnPolicy)`
  h3 {
    font-size: 14px;
    margin-bottom: 10px;
  }
  li {
    font-family: ${({ theme }) => theme.fontFamilies.gotham};
    font-size: 12px;
    line-height: 120%;
    margin-bottom: 4px;
    &:last-of-type {
      margin-bottom: 50px;
    }
  }
  ul {
    list-style: disc;
    list-style-position: inside;
    margin-top: 6px;
  },
`

export interface InvoiceContainerProps {
  className?: string
  invoice: CustomerInvoiceFragment
}

const InvoiceContainer: React.FC<InvoiceContainerProps> = ({ className, invoice }) => {
  const { search } = useLocation()
  const printParam = useMemo(() => {
    const { print } = queryString.parse(search)
    if (!print) {
      return
    }
    return print
  }, [search])

  useEffect(() => {
    if (invoice && printParam) {
      window.print()
    }
  }, [invoice, printParam])

  const handlePrint = () => {
    window.print()
  }

  return (
    <div className={className}>
      <StyledHeader>Invoice #{invoice.invoiceNumber}</StyledHeader>
      <StyledActions>
        {!!invoice.createdFromOrder && (
          <SecondaryButton
            as={Link}
            to={`/account/orders/${invoice.createdFromOrder?.orderNumber}`}
          >
            See Related Order
          </SecondaryButton>
        )}
        <SecondaryButton text="Print This Invoice" onClick={handlePrint} />
      </StyledActions>
      <InvoiceDetails invoice={invoice} />
      <InvoiceContents invoice={invoice} />
      <InvoiceTotal invoice={invoice} />
      <hr />
      <StyledReturnPolicy />
    </div>
  )
}

const StyledInvoiceContainer = styled(InvoiceContainer)`
  @media print {
    button {
      display: none;
    }
  }
`

export default StyledInvoiceContainer
